import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addMotivationFeedback, getfeedbackMotivation, saveMotivationFeedbacksToProd } from '../../actions';

import './feedback.css';

class FeedbackMotivation extends Component {

  initState = {
    checked: [],
    motivationSearch: '',
    show: false,
    _id: '',
    text:'',
    speech: '',
    workout_part_label: '',
    type:'',
    state:'WORK',
    repeated: null,
    level: null,
    gender: null
  }

  state = {
    ...this.initState,
    workoutPartLabels: ['START', 'MIDDLE', 'END', 'LAST_WORKOUT_OF_THE_WEEK', 'MIDDLE_OF_WORKOUT', 'END_OF_WORKOUT'],
    types: ['EXERCISE_ABOUT_TO_END', 'EXERCISE_ABOUT_TO_END_INDICATION', 
        'END_OF_EXERCISE', 'LAST_WORKOUT_OF_THE_WEEK', 'MIDDLE_OF_WORKOUT', 'END_OF_WORKOUT', 'CORRECTION'],
    states: ['WORK','REST'],
    motivationAll: [],
    motivation: [],
    empty: ''
  }

  componentWillMount = () => {
    this.props.getfeedbackMotivation();
  }

  componentWillReceiveProps = (nextProps) => {
    if(nextProps.motivation) {
      this.setState({
        motivationAll: nextProps.motivation,
        motivation: nextProps.motivation
      })
    }

    if (nextProps.newFeedback) {
      this.props.getfeedbackMotivation();
    }
  }

  handleChange = (evt, field) => {
    const value = evt.target.value;
    const name = evt.target.name;
    
    if(field) {
      this.setState({
        [field]:{
          ...this.state[field],
          [name]: value
        }
      })
    } else{
      this.setState({
        ...this.state,
        [name]: value
      });
    }

    if(evt.target.name === 'motivationSearch') {
      this.setState({
        motivation: this.state.motivationAll.filter(
          moti => moti.workout_part_label.includes(value) || 
          moti.type.includes(value) || moti.state.includes(value)
          )
      })
    }

  }



  showModal = () => {
    this.setState({show: true});
  }

  hideModal = () => {
    this.setState({
      show: false,
    });
  }

  submitForm = async (e) => {
    e.preventDefault();
    await this.props.addMotivationFeedback(this.state);

    this.setState({
      ...this.initState
    })
  }

  editFeedback = (feedback) => {
    this.showModal();

    if (this.state.checked.length >= 1) {
      this.setState({...this.initState})
    } else {
      this.setState({
        _id: feedback._id,
        text: feedback.text,
        speech: feedback.speech,
        workout_part_label: feedback.workout_part_label,
        type: feedback.type,
        state: feedback.state,
        repeated: feedback.repeated,
        level: feedback.level,
        gender: feedback.gender
      })
    }
  }

  addNewFeedback = () => {
    this.showModal();
    this.setState({
      ...this.initState
    })
  }

  renderMotivation = () => (
    this.state.motivation.map((motivation, i) => {
      return <div key={i} className="inline-row inline-row-motivation" onClick={()=> this.editFeedback(motivation)}>
         <div className="column column-checkbox" style={{border: 'none'}}><input  className="checkbox" type="checkbox" name="workoutCheckbox" 
          checked={this.state.checked.indexOf(motivation._id) === -1 ? false : true }
          onChange={() => this.checkboxClick(motivation)}/></div>
        <div className="column-motivation hover">{motivation.workout_part_label || "--------"}</div>
        <div className="column-motivation hover">{motivation.type}</div>
        <div className="column-motivation column-state hover">{motivation.state}</div>
      </div>
    }) 
  )
  
  renderSelect = (options) => (
    options.map((lable, i) => {
      return <option key={i} value={lable}> {lable} </option>
    })
  )

  checkboxClick = (feedback) => {
    let index = this.state.checked.indexOf(feedback._id);
    if(index !== -1) {
      let checked = this.state.checked.filter(checkedW => checkedW !== feedback._id)
      
      this.setState({
        checked
      })
    } else {
      this.setState({
        checked: [...this.state.checked, feedback._id]
      })
    }
  }

  addToProduction = () => {
    let feedbacks = [];
    this.state.checked.forEach(id => {
      feedbacks.push(this.state.motivationAll.find(feedback => feedback._id === id));
    })

    this.setState({
      ...this.initState
    })
    if(feedbacks.length > 0) {
      this.props.saveMotivationFeedbacksToProd(feedbacks);
    }
  }

  render() {
    return (
      <div>
        <div className="inline">
          <div className="motivation-div">
            <h2 className="headline">Motivation</h2>
            <div className="block">
            <input type="text" placeholder="Search"  name="motivationSearch" value={this.state.motivationSearch} onChange={this.handleChange} className="select-motivation search-input"/>
              {
                process.env.REACT_APP_ENVIRONMENT !== 'production'  ?
                  <button onClick={this.addToProduction} className="addButton final-btn final-btn-feedback">Add To Production</button>
                : null
              }
            </div>
            <div className="specific-feedbacks-head inline-row inline-row-motivation">
            <div className="column column-checkbox" style={{border: 'none'}} ></div>
              <div className="column-motivation column-head">Workout Part Lable</div>
              <div className="column-motivation column-head">Type</div>
              <div className="column-motivation column-state column-head">State</div>
            </div>
            <div className="specific-feedbacks">
              <div className="names">{this.renderMotivation()}</div>
            </div>
          </div>
            <form onSubmit={this.submitForm} className="add-form"> 
              <div style={{display: 'grid'}}>
              <select className="select-motivation input-motivation"  name="workout_part_label" type="text" 
                placeholder="Workout part lable" 
                value={this.state.workout_part_label} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.workoutPartLabels)}
              </select>
              {/* <input className="input input-motivation"  name="type" type="text" 
                placeholder="Type" 
                value={this.state.type} onChange={this.handleChange} /> */}
              <select className="select-motivation input-motivation"  name="type" type="text" 
                placeholder="Type" 
                value={this.state.type} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.types)}
              </select>
              <select className="select-motivation input-motivation"  name="state" type="text" 
                placeholder="State" 
                value={this.state.state} onChange={this.handleChange}>
                <option>Select</option>
                {this.renderSelect(this.state.states)}
              </select>
                 <input 
                    name="praise"
                    type="text" 
                    className="input input-motivation"
                    placeholder="Text Praise"
                    value={this.state.text.praise || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'text')}}
                />
                <input 
                    name="praise"
                    type="text"
                    className="input input-motivation"
                    placeholder="Speech Praise"
                    value={this.state.speech.praise || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'speech')}}
                />
                <input 
                    name="encourage"
                    type="text" 
                    className="input input-motivation"
                    placeholder="Text Encourage"
                    value={this.state.text.encourage || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'text')}}
                />
                <input 
                    name="encourage"
                    type="text"
                    className="input input-motivation"
                    placeholder="Speech Encourage"
                    value={this.state.speech.encourage || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'speech')}}
                />
                 <input 
                    name="indication"
                    type="text" 
                    className="input input-motivation"
                    placeholder="Text Indication"
                    value={this.state.text.indication || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'text')}}
                />
                <input 
                    name="indication"
                    type="text"
                    className="input input-motivation"
                    placeholder="Speech Indication"
                    value={this.state.speech.indication || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'speech')}}
                />
                <input 
                    name="inspiration"
                    type="text"
                    className="input input-motivation"
                    placeholder="Text inspiration"
                    value={this.state.text.inspiration || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'text')}}
                />
                <input 
                    name="inspiration"
                    type="text"
                    className="input input-motivation"
                    placeholder="Speech Inspiration"
                    value={this.state.speech.inspiration || this.state.empty}
                    onChange={(e) => {this.handleChange(e, 'speech')}}
                />
                </div>
              <button type="submit" className="savebtn" onClick={this.submitForm}>Save</button> 
            </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    motivation: state.feedback.motivation,
    newFeedback: state.feedback.newFeedback,
    addToProd: state.feedback.addMotivationToProd
  }
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ addMotivationFeedback, getfeedbackMotivation, saveMotivationFeedbacksToProd },dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(FeedbackMotivation);